<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button @click="$router.go(-1)" variant="outline-primary" class="mx-2">
            <i class="mc-fa icon-outline_arrow-left"></i> {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="mc-liveview mc-route__monitoring clearfix">
      <GoogleMap :geometry="geometry" :radio="radio" />
      <SideBar @onGetRoute="onGetRoute" @onChangeSettingLine="onChangeSettingLine" />
    </div>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import GoogleMap from './GoogleMap'
import SideBar from './SideBar'
import { MixPanel } from '@/mixin/mixpanel'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Route',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    SideBar,
    GoogleMap,
  },

  mixins: [MixPanel],

  data() {
    return {
      geometry: {},

      //chamge by emit modal route
      radio: {
        primary: true,
        alternative: true,
        actual: true,
      },
    }
  },

  computed: {
    title() {
      return this.$t('route.routeMonitoring.title')
    },
  },

  mounted() {
    this.track('View Route Tracking')
  },
  methods: {
    onGetRoute(route) {
      this.geometry = route
    },

    onChangeSettingLine(radio) {
      this.radio = radio
    },
  },
}
</script>
